import React, { memo } from "react";
import { TimerPill } from "@cart-ui/widgets/timer-pill";
import { ICrossSellHeader } from "@swiggy-private/cart-types";

export interface MagicItemsTimerPillProps {
    presentationInfo: ICrossSellHeader["presentationInfo"];
    showMagicItemsUI: boolean;
    onTimerComplete: () => void;
    onTimerStart: () => void;
    onUrgencyTimeReached: () => void;
    onTimerExpired?: VoidFunction;
    storageKey?: string;
}

const MagicItemsTimerPill = ({
    presentationInfo,
    showMagicItemsUI,
    onTimerComplete,
    onTimerStart,
    onUrgencyTimeReached,
    onTimerExpired,
    storageKey,
}: MagicItemsTimerPillProps) => {
    const timerData = presentationInfo?.timer_data;
    const duration = timerData?.remaining_time?.time_in_sec;
    const fillThreshold = timerData?.urgency_time?.time_in_sec;

    // Hide timer ONLY when:
    // 1. Backend returns no duration (0 or undefined) - backend confirms expiry
    // 2. Magic items UI is not active
    if (!duration || !showMagicItemsUI) {
        return null;
    }

    return (
        <TimerPill
            duration={duration}
            fillThreshold={fillThreshold}
            onTimerComplete={onTimerComplete}
            onTimerStart={onTimerStart}
            onUrgencyTimeReached={onUrgencyTimeReached}
            onTimerExpired={onTimerExpired}
            defaultTextColor={timerData?.remaining_time?.color}
            defaultBgColor={timerData?.remaining_time?.bg_color}
            urgencyTextColor={timerData?.urgency_time?.color}
            urgencyBgColor={timerData?.urgency_time?.bg_color}
            storageKey={storageKey}
        />
    );
};

export default memo(MagicItemsTimerPill);
